import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import NewsCard from "@/components/base/NewsCard";
import { getPublicNews } from "@/lib/webContentApi";
import { NewsItem } from "@/lib/webContentTypes";

export default function NewsSection() {
  const [latest, setLatest] = useState<NewsItem[]>([]);

  useEffect(() => {
    getPublicNews(4)
      .then((items) => setLatest(items.filter((item) => item.active).slice(0, 4)))
      .catch(() => setLatest([]));
  }, []);

  return (
    <section className="py-20 px-4 md:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
          <div>
            <span className="text-sky-500 text-sm font-semibold uppercase tracking-wider">Ultimas novedades</span>
            <h2
              className="text-3xl md:text-4xl font-extrabold text-sky-900 mt-1"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              Noticias del APR
            </h2>
            <p className="text-slate-500 mt-2 text-base">
              Mantente informado sobre las ultimas novedades de tu comunidad.
            </p>
          </div>
          <Link
            to="/noticias"
            className="flex items-center gap-2 px-6 py-3 rounded-full border-2 border-sky-500 text-sky-600 font-semibold text-sm hover:bg-sky-50 transition-colors cursor-pointer whitespace-nowrap self-start md:self-auto"
          >
            Ver todas las noticias <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latest.map((news, i) => (
            <NewsCard key={news.id} news={news} featured={i === 0} />
          ))}
        </div>
      </div>
    </section>
  );
}
